<script>
  import CBrow from "./CBrow.svelte";
  import * as animateScroll from "svelte-scrollto";
  export let scrollY;
  let outerWidth;
  let outerHeight;

  function scrollToElement(element, offset, top) {
    if (top) {
      animateScroll.scrollToTop();
    } else {
      animateScroll.scrollTo({element: element, offset: offset});
    }
    navExpand = false;
  }
</script>

<style>
  .content {
    padding-top: 200px;
    min-height: 600px;
  }

  .tagline {
    font-size: 1.9rem;
    font-family: 'Deja Vu Sans', sans-serif;
    float: left;
    position: relative;
    min-height: 150px;
    font-weight: 900;
    max-width: 450px;
    text-align: left;
    padding-top: 25px;
    padding-bottom: 50px;
    line-height: 1;
    font-stretch: extra-condensed;
    padding-left: 25px;
  }

  button {
    display: block;
    margin-top: 25px;
    padding: 5px 15px 5px 15px;
    font-size: 16px;
    transition: all 0.4s;
  }

  button:hover {
    background-color: var(--palette-grad1);
    color: white;
  }

  .tagContainer {
    background-size: cover;
    overflow: hidden;
    position: absolute;
    width: 100%;
  }

  .shape {
    height: 300px;
    width: 460px;
    background-color: var(--palette-grad2);
    margin-left: -20px;
    position: relative;
    top: -70px;
    transform: rotate(15deg);
  }

  @media screen and (max-width:576px) {
    .tagContainer {
      width: 350px;
    }

    .tagline {
      max-width: 320px;
      font-size: 1.5rem;
    }

    .shape {
      height: 250px;
      width: 325px;
    }
  }

  @media screen and (max-width:767px) {
    .content {
      padding-top: 153px;
      min-height: 503px;
    }
  }

  @media screen and (min-width: 1600px) {
    .parallax-container {
      width: 100%;
    }
  }

  @media screen and (max-width: 1599px) {
    .parallax-container {
      width: 1800px;
    }
  }

  @media screen and (max-width: 991px) {
    .parallax-container {
      width: 2300px;
    }
  }

  .parallax-container {
    position: fixed;
    /* width: 2300px; */
    height: 712px;
    left: 50%;
    transform: translate(-50%,0);
  }

  .parallax-container img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
  }

  .button {
    display: inline-block;
    margin-top: 25px;
    padding: 5px 15px 5px 15px;
    font-size: 12px;
    transition: all 0.4s;
    background-color: var(--palette-white);
    color: var(--palette-grad2) !important;
    line-height: 18px;
    font-weight: 400;
    font-family: 'Poppins';
  }

  .button:hover {
    background-color: var(--palette-grad1);
    color: white !important;
  }
</style>

<svelte:window bind:outerWidth bind:outerHeight></svelte:window>

<div class="parallax-container">
  <img
    style="transform: translate(0,{-scrollY * 0.5}px)"
    src="embedded6.jpg"
    alt="parallax layer">
</div>

<CBrow bgcolor="var(--palette-pop-a2)" bind:scrollY hideLeftOnSmall="true">
  <div slot="left">
    <div class="content">
      <!-- <div class="shape">
        <div class="image"></div>
      </div> -->
      <!-- Width:{outerWidth}<br>
      Height:{outerHeight} -->
    </div>
  </div>
  <div slot="right">
    <div class="content">
      <div class="tagContainer">
        <div class="shape"></div>
      </div>
      <div class="tagline">
        <div>I HELP COMPANIES REALIZE THEIR EMBEDDED SOFTWARE NEEDS</div>
        <button on:click={() => scrollToElement("#aboutme", -67, false)} class="button" role="button">LEARN MORE →</button>
      </div>
    </div>
  </div>
</CBrow>